
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34 68c18.778 0 34-15.222 34-34S52.778 0 34 0 0 15.222 0 34s15.222 34 34 34z","fill":"var(--payment-select-icon-bg, white)"}}),_c('path',{attrs:{"d":"M40.24 19.592l2.578-1.47M23.792 12.602v35.934a2.888 2.888 0 001.417 2.487l12.369 7.324a2.213 2.213 0 003.34-1.9V21.832a3.86 3.86 0 00-1.894-3.322L26.47 11.075a1.774 1.774 0 00-2.678 1.527v0z","stroke":"var(--payment-select-icon-color, black)","stroke-width":"1.417","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M24.688 11.059l2.648-1.505a1.755 1.755 0 011.741.036l12.556 7.435a3.86 3.86 0 011.894 3.322v34.61a2.194 2.194 0 01-1.127 1.928l-2.648 1.506M28.192 49.494l6.835 4.016M30.52 16.299l3.104 1.823","stroke":"var(--payment-select-icon-color, black)","stroke-width":"1.417","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    